import { render, staticRenderFns } from "./RiderProfiles.vue?vue&type=template&id=681951d4&scoped=true"
import script from "./RiderProfiles.vue?vue&type=script&lang=js"
export * from "./RiderProfiles.vue?vue&type=script&lang=js"
import style0 from "./RiderProfiles.vue?vue&type=style&index=0&id=681951d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681951d4",
  null
  
)

export default component.exports